import classNames from "classnames";
import React from "react";
import { Popup, type PopupProps } from "react-map-gl";

export const LocationPopup = ({
  longitude,
  latitude,
  closeButton,
  onClose,
  className,
  anchor = "top",
  offset = [0, 5],
  children,

  ...props
}: PopupProps) => {
  const popupStyles = classNames(
    "[&>.mapboxgl-popup-content]:rounded-2xl [&>.mapboxgl-popup-content]:border [&>.mapboxgl-popup-content]:border-neutral-300 [&>.mapboxgl-popup-content]:p-6 [&>.mapboxgl-popup-content]:shadow-xl z-[3]",
    "[&>.mapboxgl-popup-tip]:hidden",
    "md:!max-w-sm max-md:!max-w-full max-md:!translate-x-0 max-md:!translate-y-0 max-md:bottom-4 max-md:!left-4 max-md:right-4 max-md:!top-auto max-md:pt-20",
    className
  );

  return (
    <Popup
      offset={offset}
      closeButton={closeButton}
      className={popupStyles}
      anchor={anchor}
      longitude={longitude}
      latitude={latitude}
      onClose={onClose}
      {...props}
    >
      {children}
    </Popup>
  );
};
